if (typeof jQuery != "undefined") {
    (function($) {
        "use strict";

        /** Share dentist insurance check
         *
         * Specific functionality to comply with business rules in 'MijnZZ' environment on adding 'share dentist' option to your insurance
         *
         * @param input - select box containing sharing options
         */
        ZZ.ShareDentistInsuranceCheck = function(input) {
            var base = this;
            base.input = input;
            base.messageContainer = $("#" + base.input.attr("data-message-id"));
            base.url = base.input.attr("data-url");
            base.form = base.input.parents("form:first");
            base.insuranceOption = base.form.find("#additionalinsurance");
            base.template = new ZZ.Template(base.messageContainer);
            base.noSharing =
                base.input.attr("data-sharing-not-possible-with") || "";
            base.sharingNotPossibleNote = base.input.next(
                ".notification-sharing-not-possible"
            );
            base.shareMaxNote = $(".notification-sharing-maximum");
            base.assignListeners();
            base.input.trigger("change");
            base.input.get(0).dispatchEvent(new Event("change"));
            base.insuranceOption.trigger("change");
            base.get(0).dispatchEvent(new Event("change"));
        };

        ZZ.ShareDentistInsuranceCheck.prototype = {
            assignListeners: function() {
                var base = this;
                base.input.on("change", function() {
                    var selectedValue = base.input.find(":selected").val();
                    if (selectedValue !== "") {
                        base.getShareInfo();
                    } else {
                        base.hideMessage();
                    }
                });

                base.insuranceOption.on("change", function() {
                    var selectedValue = $(this).val();
                    if (base.noSharing.indexOf(selectedValue) > -1) {
                        base.input.attr("disabled", "disabled");
                        base.input[0].selectedIndex = 0;
                        base.input.trigger("change");
                        base.input.get(0).dispatchEvent(new Event("change"));
                        base.sharingNotPossibleNote.find("strong").text(
                            $(this)
                                .find(":selected")
                                .text()
                        );
                        base.sharingNotPossibleNote.fadeIn(200);
                        base.shareMaxNote.hide();
                    } else if (
                        typeof base.input.attr("disabled") !== "undefined"
                    ) {
                        base.sharingNotPossibleNote.fadeOut(200);
                        base.input.removeAttr("disabled");
                    } else {
                        base.getShareInfo();
                    }
                });
            },

            getShareInfo: function() {
                var base = this,
                    parameters = base.form.serialize(),
                    method = base.form.attr("method") || "GET";

                $.ajax({
                    url: base.url,
                    dataType: "json",
                    data: parameters,
                    type: method,
                    redirLogout: true /* redirect in case logged out (redirect-proxy.js) */,
                    success: function(data) {
                        var shareDentist = data.sharedentist;
                        if (shareDentist.toString().toUpperCase() !== "OK") {
                            shareDentist.new_insurance = base.insuranceOption
                                .find(":selected")
                                .text();
                            base.highlightMessage(shareDentist);
                        } else {
                            base.hideMessage();
                        }

                        if (
                            typeof data.maxshareamount !== "undefined" &&
                            $.trim(data.maxshareamount) !== ""
                        ) {
                            base.shareMaxNote
                                .html(data.maxshareamount)
                                .fadeIn(200);
                        }
                    },
                    error: function() {
                        base.hideMessage();
                    }
                });
            },

            highlightMessage: function(json) {
                var base = this;
                base.template.appendData(json);
                base.messageContainer.fadeIn(200).removeClass("is-hidden");
            },

            hideMessage: function() {
                var base = this;
                base.messageContainer.fadeOut(200);
            }
        };

        /** Share dentist prospect insurance check
         *
         * Specific functionality to choose share dentist option in prospect environment of ZZ site
         * Simple version: only sharing with partner is possible
         *
         */
        ZZ.ShareDentistProspectInsuranceCheck = function(checkbox) {
            var base = this;
            base.checkbox = checkbox;
            base.checkboxPartner = $("#share-dentist-partner");
            base.compareCheckboxes = base.checkbox
                .closest("fieldset")
                .prev(".compare-table-container")
                .find(":checkbox");
            base.compareTable = base.checkbox
                .closest("fieldset")
                .prev(".compare-table-container");
            base.av = $(
                $("[data-ref-bv-prospect-main]")
                    .first()
                    .attr("data-update-gemak-av-select")
            );
            base.avPartner = $(
                $("[data-ref-bv-prospect-partner]")
                    .first()
                    .attr("data-update-gemak-av-select")
            );
            //
            base.bvMain = $("[data-ref-bv-prospect-main]");
            base.bvPartner = $("[data-ref-bv-prospect-partner]");
            //
            if (base.checkboxPartner.length === 0) {
                // no partner on page
                return;
            }

            base.checkboxPartner.prop("disabled", true);
            $(".dental-sharing-not-possible-text-partner-keuze").hide(0);
            base.assignListeners();
            base.updateSharing();
        };

        ZZ.ShareDentistProspectInsuranceCheck.prototype = {
            assignListeners: function() {
                var base = this;

                base.compareTable.on(
                    "rebuild.compareTable",
                    base.reAssignListeners.bind(this)
                );

                base.checkbox.on(
                    "change.ShareDentistProspectInsuranceCheck",
                    function() {
                        // if av partner is chosen, but av main insured not yet
                        if (
                            base.av.find(":selected").prop("disabled") &&
                            !base.avPartner.find(":selected").prop("disabled")
                        ) {
                            base.avPartner.trigger(
                                "change.ShareDentistProspectInsuranceCheck"
                            );
                        } else {
                            base.updateSharing();
                        }
                    }
                );

                base.bvMain.on("change", function() {
                    if (
                        $(this)
                            .find(":selected, :checked")
                            .is("[data-no-dental-sharing], .no-dental-sharing")
                    ) {
                        base.checkbox.prop("checked", false);
                        base.checkbox.prop("disabled", true);
                        base.disableSharing();
                    } else {
                        if (
                            !base.av
                                .find(":selected")
                                .is(
                                    "[data-no-dental-sharing], .no-dental-sharing"
                                )
                        ) {
                            base.checkbox.prop("disabled", false);
                            base.enableSharing();
                        }
                    }
                });

                base.bvPartner.on("change", function() {
                    if (
                        $(this)
                            .find(":selected, :checked")
                            .is("[data-no-dental-sharing], .no-dental-sharing")
                    ) {
                        base.checkbox.prop("checked", false);
                        base.checkbox.prop("disabled", true);
                        $(
                            ".dental-sharing-not-possible-text-partner-keuze"
                        ).show();
                        base.compareCheckboxes.prop("disabled", true);
                        base.disableSharing();
                    } else {
                        if (
                            base.av
                                .find(":selected")
                                .is(
                                    "[data-no-dental-sharing], .no-dental-sharing"
                                )
                        ) {
                            base.checkbox.prop("disabled", true);
                            base.compareCheckboxes.prop("disabled", true);
                        } else {
                            base.checkbox.prop("disabled", false);
                            base.compareCheckboxes.prop("disabled", false);
                        }

                        $(
                            ".dental-sharing-not-possible-text-partner-keuze"
                        ).hide();

                        if (base.checkbox.is(":checked")) {
                            base.enableSharing();
                        } else {
                            base.disableSharing();
                        }
                    }
                });

                base.av.on(
                    "change.ShareDentistProspectInsuranceCheck",
                    function() {
                        base.updateSharing();
                    }
                );

                base.avPartner.on(
                    "change.ShareDentistProspectInsuranceCheck",
                    function() {
                        if (base.checkbox.is(":checked")) {
                            base.av.val(base.avPartner.val());
                            base.av.trigger("change");
                            base.av.get(0).dispatchEvent(new Event("change"));
                        }
                    }
                );
            },

            /**/
            reAssignListeners: function() {
                var base = this;
                base.compareCheckboxes = base.checkbox
                    .closest("fieldset")
                    .prev(".compare-table-container")
                    .find(":checkbox");
                base.compareCheckboxes.prop(
                    "checked",
                    base.checkbox.prop("checked")
                );
                base.compareCheckboxes.prop(
                    "disabled",
                    base.checkbox.prop("disabled")
                );
                base.compareCheckboxes.on("change", function() {
                    base.checkbox.prop(
                        "checked",
                        !base.checkbox.prop("checked")
                    );
                    base.updateSharing();
                });
            },

            /**/
            updateSharing: function() {
                var base = this;

                // Show/hide span.delen / span.niet-delen
                if (base.checkbox.is(":checked")) {
                    $(".compare-table").addClass("delen");
                } else {
                    $(".compare-table").removeClass("delen");
                }

                // Show partner's aanvullende verzekering link if it's hidden
                var $linkAanvullendeVerzekering = base.avPartner
                    .parents("fieldset")
                    .find('a[data-interaction="Toggle"]');

                if (!$linkAanvullendeVerzekering.hasClass("closed")) {
                    $linkAanvullendeVerzekering.trigger("click.toggle");
                }

                if (
                    base.av
                        .find(":selected")
                        .is("[data-no-dental-sharing], .no-dental-sharing")
                ) {
                    var sharingNotPossibleText = $(
                        ".dental-sharing-not-possible-text"
                    );
                    sharingNotPossibleText.show();

                    base.checkbox.prop("disabled", true);
                    base.checkbox.prop("checked", false);
                    base.compareCheckboxes.prop("disabled", true);

                    if (
                        base.av.find(":selected").attr("data-value-none") !==
                        undefined
                    ) {
                        $(".dental-sharing-not-possible-text").hide();
                    }
                    sharingNotPossibleText
                        .find(".insurance")
                        .text(base.av.find(":selected").text());
                    base.disableSharing();
                } else {
                    base.checkbox.prop("disabled", false);
                    base.compareCheckboxes.prop("disabled", false);

                    $(".dental-sharing-not-possible-text").hide();

                    if (base.checkbox.is(":checked")) {
                        base.enableSharing();
                    } else {
                        base.disableSharing();
                    }
                }

                if (
                    base.bvPartner
                        .find(":selected, :checked")
                        .is("[data-no-dental-sharing], .no-dental-sharing")
                ) {
                    base.checkbox.prop("checked", false);
                    base.checkbox.prop("disabled", true);
                    base.compareCheckboxes.prop("disabled", true);
                    $(".dental-sharing-not-possible-text-partner-keuze").show();
                }
            },

            enableSharing: function() {
                var base = this,
                    formRowPartner = base.checkboxPartner.closest(".form-row");

                //we kunnen alleen maar delen als de partner een bv heeft waar dat mee kan
                if (
                    !base.bvPartner
                        .find(":selected, :checked")
                        .is("[data-no-dental-sharing], .no-dental-sharing")
                ) {
                    if (base.checkbox.is(":checked")) {
                        $(".compare-table").addClass("delen");
                    }

                    base.compareCheckboxes.prop("checked", true);

                    if ($.trim(base.av.val()) === "") {
                        return;
                    }
                    base.avPartner.prop("disabled", true);
                    base.avPartner.val(base.av.val());
                    base.checkboxPartner.prop("checked", true);
                    base.checkboxPartner.nextAll(".note:first").slideDown(150);
                    formRowPartner.fadeIn(100);
                    // hide 'vergelijk' button for partner (NB extensive selector, because ID is not possible, code for backend same as 'verzekeringsnemer')
                    var compareTablePartner = formRowPartner
                        .closest("fieldset")
                        .prev();
                    var compareButtonPartner = compareTablePartner
                        .prev()
                        .find("li:last");
                    compareTablePartner.hide();
                    compareButtonPartner.hide();

                    // Change label text
                    var lbl = base.checkboxPartner.next("label");
                    lbl.attr("data-text-not-shared", lbl.text());
                    lbl.text(lbl.attr("data-text-shared"));

                    // trigger for template update (getting summary)
                    base.av.trigger("change.UpdateTemplate");
                }
            },

            disableSharing: function() {
                var base = this,
                    formRowPartner = base.checkboxPartner.closest(".form-row");

                base.compareCheckboxes.prop("checked", false);

                base.avPartner.prop("disabled", false);

                $(".compare-table").removeClass("delen");

                if (base.checkbox.is(":checked")) {
                    base.avPartner.trigger("change");
                    base.avPartner.get(0).dispatchEvent(new Event("change"));
                }

                base.checkboxPartner.prop("checked", false);
                base.checkboxPartner.nextAll(".note:first").slideUp(100);
                formRowPartner.fadeOut(100);
                // show 'vergelijk' button for partner (NB extensive selector, because ID is not possible, code for backend same as 'verzekeringsnemer')
                var compareButtonPartner = formRowPartner
                    .closest("fieldset")
                    .prev()
                    .prev()
                    .find("li:last");
                compareButtonPartner.show();

                // Change label text
                var lbl = base.checkboxPartner.next("label"),
                    txt = lbl.attr("data-text-not-shared");
                if (txt) {
                    lbl.text(txt);
                }
            }
        };

        /** Share dentist prospect extended insurance check
         *
         * Specific functionality to choose share dentist option in prospect environment of ZZ site
         * Extended version for choosing whom to share with
         *
         */
        ZZ.ShareDentistProspectExtendedInsuranceCheck = function(container) {
            var base = this;
            base.container = container;
            base.sharePersons = base.container.find("[data-share-dentist-id]");
            base.triggers = base.sharePersons.find(
                "[data-share-dentist-trigger]"
            );
            base.sharingPartnerSelections = base.triggers.nextAll("select");
            base.avSelects = base.container.find("[data-share-dentist-av]");
            base.bvSelects = base.container.find(
                "[data-update-gemak-av-select]"
            );
            base.sharingStatus = false; // == true if sharing is on

            $(".dental-sharing-not-possible-text").hide(0);
            $(".dental-sharing-on-text").hide(0);
            $(".dental-sharing-not-possible-text-partner-keuze").hide(0);

            base.assignListeners();

            // sharing on init
            base.init();
        };

        ZZ.ShareDentistProspectExtendedInsuranceCheck.prototype = {
            init: function() {
                var base = this,
                    curSelect;
                // sharing 'on' if checkbox is checked
                if (base.triggers.is(":checked")) {
                    base.updateSharing($(base.triggers.filter(":checked")[0]));
                }

                // disable sharing if av doesn't allow it
                base.avSelects.each(function() {
                    curSelect = $(this);
                    if (
                        curSelect
                            .find(":selected")
                            .is("[data-no-dental-sharing], .no-dental-sharing")
                    ) {
                        var checkbox = $(
                            "[data-share-dentist-id=" +
                                curSelect.attr("data-share-dentist-av") +
                                "]"
                        ).find("[data-share-dentist-trigger]");
                        base.disableSharing(curSelect, checkbox);
                    }

                    var bvSelect = $(
                        curSelect.attr("data-update-gemak-bv-select")
                    );
                    base.renderWarningZorgGemak(bvSelect);
                });
            },

            assignListeners: function() {
                var base = this;

                //this is necessary to set the onpageload state of the checkboxes that correspond to the dental sharing checkbox
                // base.container.on('rebuild.compareTable', function(){ base.init() });

                base.triggers.on("toggle.dentalSharing", function() {
                    var checkbox = $(this),
                        id = checkbox
                            .parents("[data-share-dentist-id]:first")
                            .attr("data-share-dentist-id"),
                        select = $("[data-share-dentist-av=" + id + "]");

                    // if sharing is not supported with chosen option
                    if (
                        select
                            .find(":selected")
                            .is("[data-no-dental-sharing], .no-dental-sharing")
                    ) {
                        base.disableSharing(select, checkbox);
                    } else {
                        base.enableSharing(checkbox);
                    }

                    var bvSelect = $(
                        select.attr("data-update-gemak-bv-select")
                    );
                    base.renderWarningZorgGemak(bvSelect);

                    // trigger custom event for possible additional interaction
                    checkbox.trigger("ZZ_share_dentist_change");
                });

                base.triggers.on(
                    "change.ShareDentistProspectExtendedInsuranceCheck",
                    function() {
                        var checkbox = $(this),
                            id = checkbox
                                .parents("[data-share-dentist-id]:first")
                                .attr("data-share-dentist-id"),
                            select = $("[data-share-dentist-av=" + id + "]");

                        // if sharing is not supported with chosen option
                        if (
                            select
                                .find(":selected")
                                .is(
                                    "[data-no-dental-sharing], .no-dental-sharing"
                                )
                        ) {
                            base.disableSharing(select, checkbox);
                        } else {
                            base.enableSharing(checkbox);
                            base.updateSharing(checkbox);
                        }

                        var bvSelect = $(
                            select.attr("data-update-gemak-bv-select")
                        );
                        base.renderWarningZorgGemak(bvSelect);

                        // trigger custom event for possible additional interaction
                        checkbox.trigger("ZZ_share_dentist_change");
                    }
                );

                base.sharingPartnerSelections.on("change", function() {
                    var checkbox = $(this).prevAll(
                        "[data-share-dentist-trigger]"
                    );
                    base.updateSharing(checkbox);

                    // trigger custom event for possible additional interaction
                    var curTrigger = $(this);
                    curTrigger.trigger("ZZ_share_dentist_change");
                });

                base.bvSelects.find("input").on("change", function() {
                    var bvSelect = $(this),
                        avSelect = $(
                            bvSelect.attr("data-update-gemak-av-select")
                        );

                    base.renderWarningZorgGemak(bvSelect);
                });

                base.avSelects.on("change", function() {
                    var avSelect = $(this),
                        bvSelect = $(
                            avSelect.attr("data-update-gemak-bv-select")
                        ),
                        correspondingCheckbox = base.container.find(
                            "[data-share-dentist-id=" +
                                avSelect.attr("data-share-dentist-av") +
                                "] [data-share-dentist-trigger]"
                        );

                    // if sharing is not supported with chosen option
                    if (
                        avSelect
                            .find(":selected")
                            .is(
                                "[data-no-dental-sharing], .no-dental-sharing"
                            ) ||
                        bvSelect
                            .find(":checked")
                            .is("[data-no-dental-sharing], .no-dental-sharing")
                    ) {
                        base.disableSharing(avSelect, correspondingCheckbox);
                    }
                    // if sharing is supported, but sharing checkbox is disabled and no one is sharing
                    else if (
                        correspondingCheckbox.prop("disabled") &&
                        !base.sharingStatus
                    ) {
                        base.enableSharing(correspondingCheckbox);
                    } else if (correspondingCheckbox.is(":checked")) {
                        base.updateSharing(correspondingCheckbox);
                    }

                    var bvSelect = $(
                        avSelect.attr("data-update-gemak-bv-select")
                    );

                    base.renderWarningZorgGemak(bvSelect);

                    // trigger custom event for possible additional interaction
                    avSelect.trigger("ZZ_share_dentist_change");

                    base.avSelects.each(function() {
                        let curSelect = $(this);

                        curSelect
                            .get(0)
                            .dispatchEvent(
                                new CustomEvent("ZZ_share_dentist_change")
                            );
                    });
                });

                $(base.container).on(
                    "change",
                    ".compare-table-container :checkbox",
                    function() {
                        // toggle 'checked' status of sharing checkbox
                        var curCheck = $(this)
                            .closest(".compare-table-container")
                            .next()
                            .find("[data-share-dentist-trigger]:checkbox");
                        curCheck.prop("checked", function(i, val) {
                            return !val;
                        });
                        curCheck.trigger(
                            "change.ShareDentistProspectExtendedInsuranceCheck"
                        );

                        // trigger custom event for possible additional interaction
                        var curTrigger = $(this);
                        curTrigger.trigger("ZZ_share_dentist_change");
                        curTrigger
                            .get(0)
                            .dispatchEvent(
                                new CustomEvent("ZZ_share_dentist_change")
                            );
                    }
                );
            },

            renderWarningZorgGemak: function(bvSelect) {
                var base = this;
                var constantValueZorgEnGemakPolisOnBV = "ZVW-ZWGMK";
                var avSelect = $(bvSelect.attr("data-update-gemak-av-select"));
                var dataShareDentistAvValue = avSelect.attr(
                    "data-share-dentist-av"
                );
                var dataShareDentistIdElementListItem = $(
                    '[data-share-dentist-id="' + dataShareDentistAvValue + '"]'
                );

                if (
                    bvSelect.find(":checked, :selected").val() ===
                        constantValueZorgEnGemakPolisOnBV &&
                    base.isAvSelectedDataValueNone(avSelect)
                ) {
                    dataShareDentistIdElementListItem
                        .find(".dental-sharing-not-possible-text-partner-keuze")
                        .show(150);
                } else {
                    dataShareDentistIdElementListItem
                        .find(".dental-sharing-not-possible-text-partner-keuze")
                        .hide();
                }
            },

            isAvSelectedDataValueNone: function(avSelect) {
                return (
                    avSelect.find(":selected").attr("data-value-none") !==
                    undefined
                );
            },

            updateSharing: function(checkbox) {
                var base = this;

                setTimeout(() => {
                    base.avSelects.each(function() {
                        let curSelect = $(this);

                        curSelect
                            .get(0)
                            .dispatchEvent(
                                new CustomEvent("ZZ_share_dentist_change")
                            );
                    });
                }, 0);

                var sharePartnerId = checkbox.nextAll("select").val();
                var avSelectSharingPartner = $(
                    '[data-share-dentist-av="' + sharePartnerId + '"]'
                );

                if (checkbox.is(":checked")) {
                    avSelectSharingPartner.attr(
                        "data-share-dentist-av-remember",
                        avSelectSharingPartner.val()
                    );
                    base.updateSharingOn(checkbox);
                } else {
                    base.updateSharingOff(checkbox);
                }
            },

            updateSharingOn: function(checkbox) {
                var base = this;
                var id = checkbox
                        .parents("[data-share-dentist-id]:first")
                        .attr("data-share-dentist-id"),
                    sharePartnerId = checkbox.nextAll("select").val(),
                    partner = $(
                        "[data-share-dentist-id=" + sharePartnerId + "]"
                    );

                base.share(id, sharePartnerId);
                base.enableSharing(partner.find(":input[type=checkbox]"));
                base.sharingStatus = true;

                checkbox
                    .closest("fieldset")
                    .prev(".compare-table-container")
                    .find(".compare-table")
                    .addClass("delen");
                partner
                    .closest("fieldset")
                    .prev(".compare-table-container")
                    .find(".compare-table")
                    .addClass("delen");
            },

            updateSharingOff: function(checkbox) {
                var base = this;
                base.sharePersons
                    .find(
                        ":input:not([data-sharing-not-possible], [type=hidden])"
                    )
                    .prop("disabled", false);
                base.sharePersons
                    .find("input[type=checkbox]")
                    .prop("checked", false);
                var sharePartnerId = checkbox.nextAll("select").val();

                base.sharingStatus = false;
                base.container.find(".dental-sharing-on-text").hide();

                $(".compare-table").removeClass("delen");
            },

            getPersonsNotSharingDentistCheckBoxes: function(checkbox) {
                var base = this;
                var currentIdDataShareDentistAttribute = checkbox
                        .parents("[data-share-dentist-id]:first")
                        .attr("data-share-dentist-id"),
                    sharePartnerIdDataShareDentistAttribute = checkbox
                        .nextAll("select")
                        .val();

                var personsNotSharingDentist = $("[data-share-dentist-id]")
                    .not(
                        '[data-share-dentist-id="' +
                            currentIdDataShareDentistAttribute +
                            '"]'
                    )
                    .not(
                        '[data-share-dentist-id="' +
                            sharePartnerIdDataShareDentistAttribute +
                            '"]'
                    );

                return personsNotSharingDentist.find("input[type=checkbox]");
            },

            share: function(id, sharePartnerId) {
                var base = this,
                    i,
                    curPerson,
                    curInputs,
                    curId,
                    sharedAvSelect,
                    sharingAvPartnerSelect;

                for (i = 0; i < base.sharePersons.length; i++) {
                    curPerson = $(base.sharePersons[i]);
                    curId = curPerson.attr("data-share-dentist-id");
                    curInputs = curPerson.find(":input").not("[type=hidden]");
                    curInputs.prop("disabled", false);
                    curPerson.find(".dental-sharing-on-text").hide();

                    // sharing partner: sharing option on
                    if (curId === sharePartnerId) {
                        curPerson
                            .find("input[type=checkbox]")
                            .prop("checked", true);
                        curPerson.find("select").val(id);

                        // remember current selected AV
                        sharedAvSelect = base.container.find(
                            "[data-share-dentist-av=" + id + "]"
                        );
                        sharingAvPartnerSelect = base.container.find(
                            "[data-share-dentist-av=" + curId + "]"
                        );

                        base.prospectAutoSelectZorgZekerPolis(
                            sharedAvSelect,
                            sharingAvPartnerSelect,
                            id,
                            curId
                        );
                        base.autoSelectSameAv(
                            sharedAvSelect,
                            sharingAvPartnerSelect
                        );

                        // trigger custom event for possible additional interaction
                        sharingAvPartnerSelect.trigger("ZZ_change_av");

                        // show sharing specific text
                        curPerson.find(".dental-sharing-on-text").show();
                    } else if (curId === id) {
                        curPerson.find(".dental-sharing-on-text").show();
                    }
                    // disable others
                    else {
                        curInputs.prop("disabled", true);

                        curPerson
                            .find("input[type=checkbox]")
                            .prop("checked", false);
                    }
                }
            },

            autoSelectSameBv: function(sharedAvSelect, sharingAvPartnerSelect) {
                var sharedBv = $(
                    sharedAvSelect.attr("data-update-gemak-bv-select")
                );
                var sharingBvPartnerSelect = $(
                    sharingAvPartnerSelect.attr("data-update-gemak-bv-select")
                );
                if (sharedBv) {
                    sharingBvPartnerSelect.val(sharedBv.val()); // Make BV the same;
                    sharingBvPartnerSelect.trigger("change");
                    sharingBvPartnerSelect
                        .get(0)
                        .dispatchEvent(new Event("change"));
                }
            },

            autoSelectSameAv: function(sharedAvSelect, sharingAvPartnerSelect) {
                if (sharedAvSelect) {
                    sharingAvPartnerSelect.val(sharedAvSelect.val());
                }
            },

            /*
            With dentist sharing between a pair there is a sharing-initiator and a sharing-partner.
            When the sharing partner has has the BV ZorgGemak then it
            should be automaticaly be changed to the BV value of the Sharing-Initiator
            */
            prospectAutoSelectZorgZekerPolis: function(
                sharedAvSelect,
                sharingAvPartnerSelect,
                sharingInitiatorId,
                sharingPartnerId
            ) {
                var base = this;

                var constantValueZorgEnGemakPolisOnBV = "ZVW-ZWGMK";
                var targetSelectdBV = sharingAvPartnerSelect.attr(
                    "data-update-gemak-bv-select"
                );

                var selectdBvElement = $(targetSelectdBV);

                if (
                    selectdBvElement.find(":checked, :selected").val() ===
                    constantValueZorgEnGemakPolisOnBV
                ) {
                    base.autoSelectSameBv(
                        sharedAvSelect,
                        sharingAvPartnerSelect
                    );

                    base.enableDentalSharingCheckboxOnProspect(
                        sharingInitiatorId
                    );
                    base.enableDentalSharingCheckboxOnProspect(
                        sharingPartnerId
                    );
                }
            },

            enableDentalSharingCheckboxOnProspect: function(sharingProspect) {
                var base = this;
                base.container
                    .find(
                        "[data-share-dentist-id=" +
                            sharingProspect +
                            "] [data-share-dentist-trigger]"
                    )
                    .prop("checked", true);
            },

            // sharing is possible in combination with selected product
            enableSharing: function(sharingCheckbox) {
                var shareWithSelect = sharingCheckbox.nextAll("select:first"),
                    sharingNotPossibleText = shareWithSelect.nextAll(
                        ".dental-sharing-not-possible-text:first"
                    );

                sharingCheckbox.removeAttr("data-sharing-not-possible");
                shareWithSelect.removeAttr("data-sharing-not-possible");
                sharingCheckbox.prop("disabled", false);
                shareWithSelect.prop("disabled", false);

                sharingNotPossibleText.hide();
            },

            // sharing is not possible in combination with selected product
            disableSharing: function(avSelect, sharingCheckbox) {
                var base = this,
                    shareWithSelect = sharingCheckbox.nextAll("select:first"),
                    sharingNotPossibleText = shareWithSelect.nextAll(
                        ".dental-sharing-not-possible-text:first"
                    );

                base.avSelects.removeAttr("data-share-dentist-av-remember");

                if (sharingCheckbox.is(":checked")) {
                    $("[data-share-dentist-trigger]").prop("checked", false);
                    base.sharingStatus = false;
                    base.updateSharing(sharingCheckbox);
                }

                sharingCheckbox.attr("data-sharing-not-possible", true);
                shareWithSelect.attr("data-sharing-not-possible", true);
                sharingCheckbox.prop("disabled", true);
                shareWithSelect.prop("disabled", true);

                var selectedAvText = avSelect.find(":selected").text();
                sharingNotPossibleText.find(".insurance").text(selectedAvText);

                if (base.isAvSelectedDataValueNone(avSelect)) {
                    sharingNotPossibleText.hide();
                } else {
                    sharingNotPossibleText.show(150);
                }
            }
        };
    })(jQuery);
}
